// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__qfjCL","loaderAnimationReverse":"loading_loaderAnimationReverse__Ro8U4","loaderAnimation":"loading_loaderAnimation__cr6wm"};